import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAvatar, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@pisaka/ui';
import { Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { profilePageUrl } from '../../../helpers/urls';
import logoImg from './pisakaNew5.jpg';

interface User {
  id: number;
  name?: string;
  email: string;
}

type PropsType = {
  toggleSidebar: () => void;
  user?: User;
};

const HeaderComponent: FC<PropsType> = ({ toggleSidebar, user }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language.startsWith('en') ? 'en' : 'ru';

  const LANGUAGES = [
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'English' },
  ];

  const handleAvatarClick = () => {
    navigate(profilePageUrl);
  };

  return (
    <div className="sticky top-0 left-0 right-0 z-10 flex items-center justify-between bg-white border-b border-gray-200 shadow-sm h-[60px] px-2 lg:px-4">
      <div className="flex items-center gap-2">
        <button
          onClick={toggleSidebar}
          className="flex items-center justify-center cursor-pointer hover:opacity-70 transition-opacity"
          aria-label="Menu"
        >
          <Menu className="w-6 h-6" />
        </button>
        <a href="/" className="block w-[45px] h-[39px] bg-contain bg-no-repeat" style={{ backgroundImage: `url(${logoImg})` }} />
      </div>
      <div className="flex items-center gap-3">
        <Select value={currentLang} onValueChange={(val) => i18n.changeLanguage(val)}>
          <SelectTrigger className="w-[130px] h-8 text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {LANGUAGES.map((lang) => (
              <SelectItem key={lang.value} value={lang.value}>{lang.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        {user && +user.id ? (
          <UserAvatar
            user={user}
            size="sm"
            showName={true}
            onClick={handleAvatarClick}
            className="text-primary2 hover:text-primary"
          />
        ) : null}
      </div>
    </div>
  );
};

export default HeaderComponent;
